module.exports = __webpack_public_path__ + "img/mvp2023.6787141f.webp";